import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';

export const validate = (disclaimer, existingEntry) => {
    return checkDiff(disclaimer, existingEntry);
};
